import { derived, writable } from "svelte/store";
import jwt_decode from "jwt-decode";
import { refresh_login } from "./tastummy_login";
let stored_refresh_token = window.localStorage.getItem("refresh_token");
if (!stored_refresh_token) {
    stored_refresh_token = "";
}
let stored_user_token = window.localStorage.getItem("user_token");
if (!stored_user_token) {
    stored_user_token = "";
}
export const refresh_token = writable(stored_refresh_token);
export const user_token = writable(stored_user_token);
export const user_token_expiration = derived(user_token, set_expiration_from_jwt);
function set_expiration_from_jwt(token, set) {
    console.log("token", token);
    if (token !== "") {
        let decoded = jwt_decode(token);
        if (decoded.iss !== "https://cognito-idp.us-west-2.amazonaws.com/us-west-2_I8Hrf0tHV") {
            console.log("unknown issuer found. Logging out");
            user_token.set("");
            refresh_token.set("");
            return;
        }
        set(new Date(decoded.exp * 1000));
    }
    else {
        // set(new Date(0));
        set(null);
    }
}
let local_refresh_token;
refresh_token.subscribe((token) => {
    local_refresh_token = token;
    window.localStorage.setItem("refresh_token", token);
});
user_token.subscribe((token) => {
    window.localStorage.setItem("user_token", token);
});
let local_user_token_expiration;
user_token_expiration.subscribe((token) => {
    local_user_token_expiration = token;
});
setInterval(() => {
    let now = new Date();
    if (local_user_token_expiration && local_user_token_expiration < now) {
        refresh_login(local_refresh_token)
            .then((res) => {
            user_token.set(res.data.id_token);
        })
            .catch((e) => {
            console.log("failed to refresh token", e);
            user_token.set("");
            refresh_token.set("");
        });
    }
}, 1000);
